import { Box, Typography } from "@mui/material";

import styles from "./ADLoginLoading.module.css";
import { activeClient } from "../../_helpers/Constant";
const AuthenticationLoader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}>
      <img src={`/assets/ClientLogos/${activeClient}/app-logo-white.png`} width="200" alt="logo-notavailable" />

      <div className={styles.centerdiv}>
        <ul>
          <li></li>
          <li></li> <li></li> <li></li> <li></li>
        </ul>
      </div>

      <Typography variant="body1" className={styles.loadingMessage}>
        Logging in, please wait...
      </Typography>
    </Box>
  );
};

export default AuthenticationLoader;
